import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  @Input()
  currentStep: number;

  @Input()
  countSteppers: number;

  steppers: number[];

  constructor() { 

    this.currentStep = 0;
    this.countSteppers = 0;
    this.steppers = [];
  }

  ngOnInit(): void {
    this.generateSteppers();

    this.currentStep = this.currentStep - 1;
  }

  generateSteppers() {

    this.steppers = [];
    for(let i = 0; i < this.countSteppers; i++) {
      this.steppers.push(i + 1);
    }
  }

}
